import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'core/store';

import ChatWidget from '@flyaps/chat-widget/lib/components/ChatWidget';
import ToggleButton from 'layouts/Sidebar/ChatWidgetWrapper/ToggleButton';
import { postGuideChatMessageAction, clearGuideChatAction } from 'layouts/Sidebar/ChatWidgetWrapper/GuideChat';

import './ChatWidgetWrapper.scss';

const ChatWidgetWrapper = () => {
  const dispatch = useAppDispatch();

  const messages = useAppSelector((state) => state.guideChat.data);
  const isLoadingRespond = useAppSelector((state) => state.guideChat.isLoading);

  const menuItem = (
    isOpen, onToggleChat,
  ) => (<ToggleButton isOpen={isOpen} toggleHandler={onToggleChat} />);

  const onSendHandler = (text: string) => {
    dispatch(postGuideChatMessageAction({ message: text }));
  };

  useEffect(() => () => {
    dispatch(clearGuideChatAction());
  }, []);

  return (
    <ChatWidget
      title="FLAI"
      messages={messages}
      onSend={onSendHandler}
      subtitle="Support Agent"
      renderChatLauncher={menuItem}
      isLoadingResponse={isLoadingRespond}
      classNameMessagesCount="messages_count"
    />
  );
};

export default ChatWidgetWrapper;
